import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "./firebase";
import type { CaseWebsiteInfo } from "./central-case-website";

export type RegisterService = Record<string, string> & {
  id: string;
  title: string;
  localStart: string;
  localEnd: string;
  startAt: string;
  endAt: string;
  timeZone: string;
  registerStatus: string;
  registerStatusLabel: string;
};
export type RegisterEventCard = RegisterService & {
  personId: string;
  lovedOneName: string;
  photoUrl: string;
  slug: string;
  funeralHomeId: string;
};
export type RegisterPersonCard = {
  personId: string; fullName: string; photoUrl: string; birthDate: string; deathDate: string; eventCount: number;
};
export type RegisterWorkspace = {
  personId: string;
  fullName: string;
  funeralHomeId: string;
  person: { birthDate?: string; deathDate?: string };
  websiteInfo: CaseWebsiteInfo | null;
  version: number;
  obituary: string;
  photoUrl: string;
  events: RegisterService[];
  slug: string;
  readOnly: boolean;
};
export type WebsiteObituary = {
  fullName: string;
  sourceUrl: string;
  deathDate: string;
  photoUrl: string;
};
export async function registerAction<T>(
  action: string,
  input: Record<string, unknown> = {},
) {
  return (
    await httpsCallable<Record<string, unknown>, T>(
      getFunctions(firebaseApp, "us-east1"),
      "centralRegisterWorkspace",
    )({ ...input, action })
  ).data;
}
export function registerError(error: unknown) {
  const code =
    error && typeof error === "object" && "code" in error
      ? String(error.code)
      : "";
  if (
    error instanceof Error &&
    [
      "invalid-argument",
      "failed-precondition",
      "resource-exhausted",
      "unavailable",
      "aborted",
    ].some((value) => code.endsWith(value))
  )
    return error.message;
  if (code.endsWith("permission-denied") || code.endsWith("unauthenticated"))
    return "Your account cannot complete this event action. Sign in again or contact your administrator.";
  return "The event action could not be completed. Please try again. Your saved details have been kept.";
}
